import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <LegalLayout title="Privacy Policy" lastUpdated="February 2026">
      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          1. Information We Collect
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          We collect the following information when you use LoBe:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li><strong>Certificate Information:</strong> Names and descriptions you provide for your certificate</li>
          <li><strong>Payment Information:</strong> Processed securely through Razorpay (we do not store card details)</li>
          <li><strong>Location Data:</strong> Approximate location for pricing purposes only</li>
          <li><strong>Usage Data:</strong> Basic analytics to improve our service</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          2. How We Use Your Information
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          We use your information to:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>Create and display your novelty certificate</li>
          <li>Process payments</li>
          <li>Generate your certificate image</li>
          <li>Improve our service</li>
          <li>Respond to support inquiries</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          3. Data Storage & Security
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          Your data is stored securely using industry-standard practices:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>All data is encrypted in transit using SSL/TLS</li>
          <li>Data is stored on secure, encrypted servers</li>
          <li>We implement access controls to protect your information</li>
          <li>Regular security audits are conducted</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          4. Data Sharing
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          We do not sell your personal information. We may share data with:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li><strong>Payment Processors:</strong> Razorpay for payment processing</li>
          <li><strong>Service Providers:</strong> Necessary third parties to operate our service</li>
          <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          5. Your Rights
        </h2>
        <p className="text-[#5A5A5A] mb-4">
          You have the right to:
        </p>
        <ul className="list-disc list-inside text-[#5A5A5A] space-y-2">
          <li>Access your personal data</li>
          <li>Request correction of inaccurate data</li>
          <li>Request deletion of your data (subject to legal requirements)</li>
          <li>Object to processing of your data</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          6. Cookies
        </h2>
        <p className="text-[#5A5A5A]">
          We use minimal cookies necessary for the operation of our service. These include session 
          cookies for authentication and analytics cookies to understand usage patterns.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          7. Changes to Privacy Policy
        </h2>
        <p className="text-[#5A5A5A]">
          We may update this Privacy Policy from time to time. We will notify you of any material 
          changes by posting the new policy on this page.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold text-[#2D2D2D] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          8. Contact Us
        </h2>
        <p className="text-[#5A5A5A]">
          For privacy-related inquiries, contact us at{" "}
          <a href="mailto:privacy@lobe.love" className="text-[#E8A0BF] hover:underline">
            privacy@lobe.love
          </a>
        </p>
      </section>
    </LegalLayout>
  );
};

export default PrivacyPage;
